<!-- <app-header></app-header> -->
<router-outlet></router-outlet>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>

<div id="attractions" class="nearby-places-section">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-cards-container">
    <div class="card unique-card">
      <img src="assets/images/Trimbakeshwar Jyotirling Mandir.webp" class="card-img-top"
        alt="Trimbakeshwar Jyotirling Mandir">
      <div class="card-body">
        <p class="card-text">Trimbakeshwar Jyotirling Mandir</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Shree Saptashrungi Nivasini Devi Mandir.webp" class="card-img-top"
        alt="Shree Saptashrungi Nivasini Devi Mandir">
      <div class="card-body">
        <p class="card-text">Shree Saptashrungi Nivasini Devi Mandir</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Dugarwadi Waterfall.webp" class="card-img-top" alt="Dugarwadi Waterfall">
      <div class="card-body">
        <p class="card-text">Dugarwadi Waterfall</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Coin Museum (Shanti-Krishna Museum of Money and History).webp" class="card-img-top"
        alt="Coin Museum (Shanti-Krishna Museum of Money and History)">
      <div class="card-body">
        <p class="card-text">Coin Museum (Shanti-Krishna Museum of Money and History)</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Gangapur Dam.jpg" class="card-img-top" alt="Gangapur Dam">
      <div class="card-body">
        <p class="card-text">Gangapur Dam</p>
      </div>
    </div>
  </div>
</div>




<div class="gallery-container">
  <!-- Dynamic property images carousel in mobile view -->
  <div class="gallery-images-section">
    <h2>Our Gallery</h2>

    <!-- Carousel view for mobile devices -->
    <ngx-slick-carousel class="gallery-carousel" *ngIf="isMobileView" [config]="slideConfig">
      <div ngxSlickItem *ngFor="let image of property?.imageList" class="gallery-image-card">
        <img [src]="image.url" alt="Property Image">
      </div>
    </ngx-slick-carousel>

    <!-- Grid view for larger screens -->
    <div class="gallery-image-grid" *ngIf="!isMobileView">
      <div class="gallery-image-card" *ngFor="let image of property?.imageList">
        <img [src]="image.url" alt="Property Image">
      </div>
    </div>
  </div>
</div>








<div class="container my-5">
  <div class="row" id="testimonials">
    <!-- First Column -->
    <div class="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-start">
      <h2 class="headline font-weight-bold mb-3">Real Stays, Real Talk</h2>
      <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
      <a href="https://search.google.com/local/writereview?placeid=ChIJkx8SNuuR3TsRsKZpLc_LoJc"
        class="btn btn-primary btn-lg writereview">
        <div style="padding-left: 10px;padding-right: 10px; color: black;">
          Write a Review
        </div>
      </a>
    </div>

    <!-- Second Column (Carousel for Desktop) -->
    <div class="col-md-8 mb-4 d-md-block">
      <div class="carousel-controls">
        <a href="#carouselExampleControlsreview" role="button" data-slide="prev" class="carousel-control-prev">
          <span aria-hidden="true" class="carousel-control-prev-icon"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a href="#carouselExampleControlsreview" role="button" data-slide="next" class="carousel-control-next">
          <span aria-hidden="true" class="carousel-control-next-icon"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <div class="card shadow-sm border-0 h-100">
        <div id="carouselExampleControlsreview" data-ride="carousel" class="carousel slide">
          <div class="carousel-inner style_carasol" style="display: block;">
            
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Ved Bhandare" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Chirag Yadav</h5>
                    <p class="small text-muted mb-2 review-text">Grand Ashwin Executive Hotel : A Serene Retreat
                      Located on the Mumbai Agra highway, Grand Ashwin Hotel offers a tranquil escape from the bustling city. The hotel's rooms are impeccably clean and provide stunning views of the surrounding landscapes. The friendly and attentive staff made our stay even more enjoyable. While the food was slightly pricier than expected, the quality and taste were certainly worth it. If you're looking for a peaceful getaway with comfortable accommodations and delicious cuisine, Grand Ashwin Executive is an excellent choice.</p>
                    <div class="star-ratings text-warning">★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Vaishali Kokane" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">
                      Mukta Chorgade</h5>
                    <p class="small text-muted mb-2 review-text">Best place to stay with good service..cleans room with low peice nice place.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item active carousel-item-left">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="DR.SACHIN NARHAR JOSHI" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Kavita Vaidya</h5>
                    <p class="small text-muted mb-2 review-text">Hotel Grand Ashwin Executive: Centrally located in the industrial area of Gonde, Nashik,Hotel grand ashwin executive is one of the best hotels in Gonde. It's a new hotel and spacious parking is available. Food facility not available in the hotel. The rooms are very clean. Good service and staff is very cooperative.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item carousel-item-next carousel-item-left">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="shyam mourya" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Vidheya C</h5>
                    <p class="small text-muted mb-2 review-text">Its on highway and easily accessible to people coming from Mumbai by own transport. Rooms are Spacious enough with hygenic bathroom. Food is priced reasonably and is good. Its little far from Nashik and is highly recommended to people travelling by Car.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Koustubh Mangrulkar" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">ISHWAR Gaikar</h5>
                    <p class="small text-muted mb-2 review-text">Great for stay and dinner lunch❤️</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">John Cardoza</h5>
                    <p class="small text-muted mb-2 review-text">Very affordable, staff is good but electricity is off on many times, one has to be strict about the service. Loved the place next to Samsonite company. Didn't like the tea and coffee served there.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    

    <!-- Carousel Controls Positioned Outside -->
    <div class="carousel-controls">
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</div>


<div id="location" style="margin-bottom: 2px;">
  <div style="position: relative; width: 100%; max-width: 100%; height: 600px;">
    <!-- The iframe -->
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120101.18787968425!2d73.59439730068317!3d19.833092088580074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bdd91eb36121f93%3A0x97a0cbcf2d69a6b0!2sGonde%20Industial%20Area%2C%20Near%20Samsonite%20Luggage%20Factory%2C%20Gondedumala%2C%20Maharashtra%20422010!3m2!1d19.833111!2d73.676799!5e0!3m2!1sen!2sin!4v1734956014450!5m2!1sen!2sin"
      width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"></iframe>
    <div class="card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px;">
      <h3>Make Unforgettable Memories</h3>
      <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to
        us.</p>
      <button class="book-btn" (click)="navigate()">Book Your Stay</button>
      <p class="contact-footer">
        <i class="fa fa-phone"></i> {{property?.mobile}}
      </p>
      <p class="contact-footer">
        <i class="fa fa-envelope"></i> {{property?.email}}
      </p>

    </div>

  </div>
</div>
<!-- Dialogflow Messenger Integration -->

<df-messenger project-id="impactful-name-306810" agent-id="8bb6c52c-8667-4a24-a789-4cd78b154c96" intent="WEBSITE"
  storage-option="none" language-code="en" max-query-length="-1">
  <df-messenger-chat-bubble id="chatbot" chat-subtitle=""></df-messenger-chat-bubble>
</df-messenger>
<a [href]="getWhatsappShareUrl()" class="float" target="_blank">
  <i class="fa fa-whatsapp my-float"></i>
</a>

<app-footer></app-footer>